var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("vxe-grid", {
    ref: "xGrid",
    staticClass: "my-grid66",
    attrs: {
      border: "",
      resizable: "",
      "show-footer": "",
      id: _vm.id,
      "custom-config": {
        storage: true,
        checkMethod: _vm.checkColumnMethod
      },
      "footer-method": _vm.footerMethod,
      columns: _vm.tableColumn,
      data: _vm.tableData,
      "toolbar-config": _vm.tableToolbar,
      "checkbox-config": {
        labelField: "date_str"
      },
      "export-config": _vm.exportConfig,
      "show-overflow": "ellipsis",
      "scroll-y": _vm.scrollYConfig,
      "max-height": "700"
    },
    on: {
      "sort-change": _vm.sortChangeEvent
    },
    scopedSlots: _vm._u([{
      key: "toolbar_buttons",
      fn: function fn() {
        return [_vm._t("toolbar_buttons")];
      },
      proxy: true
    }, {
      key: "toolbar_tools",
      fn: function fn() {
        return undefined;
      },
      proxy: true
    }, {
      key: "pager",
      fn: function fn() {
        return [_vm.isShowPager ? _c("vxe-pager", {
          attrs: {
            perfect: "",
            "current-page": _vm.tablePage.currentPage,
            "page-size": _vm.tablePage.pageSize,
            total: _vm.tablePage.totalResult,
            "page-sizes": [1000, 2000, 3000]
          },
          on: {
            "update:currentPage": function updateCurrentPage($event) {
              return _vm.$set(_vm.tablePage, "currentPage", $event);
            },
            "update:current-page": function updateCurrentPage($event) {
              return _vm.$set(_vm.tablePage, "currentPage", $event);
            },
            "update:pageSize": function updatePageSize($event) {
              return _vm.$set(_vm.tablePage, "pageSize", $event);
            },
            "update:page-size": function updatePageSize($event) {
              return _vm.$set(_vm.tablePage, "pageSize", $event);
            },
            "page-change": _vm.handlePageChange
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, true)
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };